(function () {
  const SECTION_ID = 'cart-drawer';

  function getRoot() {
    return document.querySelector('[data-cart-drawer]');
  }

  function getSectionUrl() {
    const root = window.EatShopify?.routes?.root;
    if (typeof root === 'string' && root.length > 0 && root !== '/') {
      const base = root.endsWith('/') ? root.slice(0, -1) : root;
      return `${base}/?sections=${SECTION_ID}`;
    }
    return `/?sections=${SECTION_ID}`;
  }

  function closeMobileMenuIfOpen() {
    const overlay = document.querySelector('[data-mobile-overlay]');
    const toggle = document.querySelector('[data-mobile-menu-toggle]');
    if (!overlay?.classList.contains('is-open')) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    toggle?.classList.remove('is-open');
    toggle?.setAttribute('aria-expanded', 'false');
    toggle?.setAttribute('aria-label', 'Open menu');
    document.body.style.overflow = '';
  }

  function parseSectionHtml(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector('[data-cart-drawer-replace]');
  }

  async function refreshDrawerContents() {
    const root = getRoot();
    if (!root) return;
    const current = root.querySelector('[data-cart-drawer-replace]');
    if (!current) return;
    try {
      const res = await fetch(getSectionUrl());
      if (!res.ok) return;
      const data = await res.json();
      const fragment = data[SECTION_ID];
      if (typeof fragment !== 'string') return;
      const next = parseSectionHtml(fragment);
      if (next) {
        current.innerHTML = next.innerHTML;
      }
    } catch {
      /* ignore network errors */
    }
  }

  function cartJsUrl() {
    return window.EatShopify?.routes?.cart_js || '/cart.js';
  }

  function cartChangeUrl() {
    return window.EatShopify?.routes?.cart_change_js || '/cart/change.js';
  }

  async function updateHeaderCount() {
    const trigger = document.querySelector('[data-cart-drawer-open]');
    if (!trigger) return;
    try {
      const res = await fetch(cartJsUrl());
      if (!res.ok) return;
      const cart = await res.json();
      let badge = trigger.querySelector('.header__cart-count');
      if (cart.item_count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'header__cart-count';
          trigger.insertBefore(badge, trigger.firstChild);
        }
        badge.textContent = cart.item_count;
      } else {
        badge?.remove();
      }
    } catch {
      /* ignore */
    }
  }

  async function setLineQuantity(lineKey, quantity) {
    const q = Math.max(0, Math.floor(Number(quantity) || 0));
    try {
      const res = await fetch(cartChangeUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ id: lineKey, quantity: q }),
      });
      if (!res.ok) return;
      await refreshDrawerContents();
      await updateHeaderCount();
    } catch {
      /* ignore */
    }
  }

  let lastFocus = null;

  function openDrawer() {
    const root = getRoot();
    const panel = root?.querySelector('[data-cart-drawer-panel]');
    if (!root || !panel) return;
    closeMobileMenuIfOpen();
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
    document.body.style.overflow = 'hidden';
    lastFocus = document.activeElement;
    panel.focus({ preventScroll: true });
  }

  function closeDrawer() {
    const root = getRoot();
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
    document.body.style.overflow = '';
    if (lastFocus && typeof lastFocus.focus === 'function') {
      lastFocus.focus({ preventScroll: true });
    }
    lastFocus = null;
  }

  function isOpen() {
    return getRoot()?.classList.contains('is-open');
  }

  async function openCartDrawerWithRefresh() {
    await refreshDrawerContents();
    openDrawer();
  }

  function init() {
    const root = getRoot();
    if (!root) return;

    document.querySelectorAll('[data-cart-drawer-open]').forEach((el) => {
      el.addEventListener('click', async (e) => {
        e.preventDefault();
        await openCartDrawerWithRefresh();
      });
    });

    root.addEventListener('click', (e) => {
      if (e.target.closest('[data-cart-drawer-close]')) {
        e.preventDefault();
        closeDrawer();
        return;
      }
      const dec = e.target.closest('[data-cart-line-decrease]');
      if (dec?.dataset.lineKey) {
        e.preventDefault();
        const input = root.querySelector(
          `[data-cart-line-input][data-line-key="${dec.dataset.lineKey}"]`
        );
        const q = parseInt(input?.value || '1', 10);
        setLineQuantity(dec.dataset.lineKey, Math.max(0, q - 1));
        return;
      }
      const inc = e.target.closest('[data-cart-line-increase]');
      if (inc?.dataset.lineKey) {
        e.preventDefault();
        const input = root.querySelector(
          `[data-cart-line-input][data-line-key="${inc.dataset.lineKey}"]`
        );
        const q = parseInt(input?.value || '1', 10);
        setLineQuantity(inc.dataset.lineKey, q + 1);
        return;
      }
      const rm = e.target.closest('[data-cart-line-remove]');
      if (rm?.dataset.lineKey) {
        e.preventDefault();
        setLineQuantity(rm.dataset.lineKey, 0);
      }
    });

    root.addEventListener('change', (e) => {
      const input = e.target.closest('[data-cart-line-input]');
      if (!input?.dataset.lineKey) return;
      setLineQuantity(input.dataset.lineKey, input.value);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isOpen()) {
        closeDrawer();
      }
    });

    document.addEventListener('eatshopify:cart-change', async (e) => {
      await refreshDrawerContents();
      await updateHeaderCount();
      if (e.detail?.openDrawer) {
        openDrawer();
      }
    });

    window.EatShopify = window.EatShopify || {};
    window.EatShopify.openCartDrawer = openCartDrawerWithRefresh;
    window.EatShopify.closeCartDrawer = closeDrawer;
    window.EatShopify.refreshCartDrawer = refreshDrawerContents;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
